import { Component, Input } from '@angular/core';
import { ConversionCardVm } from '../../../../domain/model/conversion-metrics.model';

/** One conversion card: title, the rate with an inline comparison slot, the indicator, and the `n of N` footer. */
@Component({
  selector: 'ifbp-conversion-rate-card',
  templateUrl: './conversion-rate-card.component.html',
  styleUrls: ['./conversion-rate-card.component.scss'],
  standalone: false,
})
export class ConversionRateCardComponent {
  @Input() vm: ConversionCardVm;
}
